// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    Elements,
} from '@stripe/react-stripe-js'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    useLocation,
} from 'react-router-dom'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    EditBlockSite,
    ButtonHelper810Site,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template810SiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
    parseQuerySite,
} from 'services'

// props
type TemplateBlock810SiteProps = {
    blockId: string
    content: Template810SiteSerializer | undefined
    isEditHovered: boolean
    isInComponent?: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock810Site: React.FC<TemplateBlock810SiteProps> = React.memo(({
    blockId,
    content,
    isEditHovered,
    isInComponent,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxCacheSiteportfoliocurrencyiso_code = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.currency?.iso_code)
    const reduxCacheSiteportfolioid = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.id)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    const [amount, setAmount] = useState<number>(0)
    const [amountError, setAmountError] = useState<string>()
    const [currency, setCurrency] = useState<string>('EUR')
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState<string>()
    const [isRecurent, setIsRecurent] = useState(false)
    const [stylesNew, setStylesNew] = useState<{
        amountChoiceStyles: CustomCSSProperties | undefined,
        block1Styles: CustomCSSProperties | undefined,
        block2Styles: CustomCSSProperties | undefined,
        buttonStyles: CustomCSSProperties | undefined,
        freeAmountInputStyles: CustomCSSProperties | undefined,
        freeAmountLabelStyles: CustomCSSProperties | undefined,
        infosInputStyles: CustomCSSProperties | undefined,
        infosLabelStyles: CustomCSSProperties | undefined,
        mainStyles: CustomCSSProperties | undefined,
        periodStyles: CustomCSSProperties | undefined,
        realCostTextStyles: CustomCSSProperties | undefined,
        secureTextStyles: CustomCSSProperties | undefined,
        titleStyles: CustomCSSProperties | undefined,
        // @ts-ignore
    } | undefined>(applyStyles())

    useEffect(() => {
        const tempStyles = applyStyles()
        // @ts-ignore
        setStylesNew(tempStyles)

    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            const aStyles = getStylesNew(reduxModalSite, styles, stylesEdit)
            return {
                amountChoiceStyles: {
                    background: aStyles?.donationAmountChoiceBackground,
                    borderColor: aStyles?.donationAmountChoiceBorderColor,
                    borderRadius: aStyles?.donationAmountChoiceBorderRadius,
                    borderStyle: aStyles?.donationAmountChoiceBorderStyle,
                    borderWidth: aStyles?.donationAmountChoiceBorderWidth,
                    color: aStyles?.donationAmountChoiceColor,
                    fontSize: aStyles?.donationAmountChoiceFontSize,
                    fontWeight: aStyles?.donationAmountChoiceFontWeight,
                    hoverBorderColor: aStyles?.donationAmountChoiceHoverBorderColor,
                    padding: aStyles?.donationAmountChoicePadding,
                },
                block1Styles: {
                    background: aStyles?.donationBlock1Background,
                    borderRadius: aStyles?.donationBlock1BorderRadius,
                    padding: aStyles?.donationBlock1Padding,
                },
                block2Styles: {
                    background: aStyles?.donationBlock2Background,
                    borderRadius: aStyles?.donationBlock2BorderRadius,
                    padding: aStyles?.donationBlock2Padding,
                },
                buttonStyles: {
                    buttonBackground: aStyles?.buttonBackground,
                    buttonBorderColor: aStyles?.buttonBorderColor,
                    buttonHoverBackground: aStyles?.buttonHoverBackground,
                    buttonHoverBorderColor: aStyles?.buttonHoverBorderColor,
                    buttonHoverTextColor: aStyles?.buttonHoverTextColor,
                    buttonTextColor: aStyles?.buttonTextColor,
                },
                freeAmountInputStyles: {
                    background: aStyles?.donationFreeAmountInputBackground,
                    borderColor: aStyles?.donationFreeAmountInputBorderColor,
                    borderRadius: aStyles?.donationFreeAmountInputBorderRadius,
                    borderStyle: aStyles?.donationFreeAmountInputBorderStyle,
                    borderWidth: aStyles?.donationFreeAmountInputBorderWidth,
                    color: aStyles?.donationFreeAmountInputColor,
                    fontFamily: aStyles?.donationFreeAmountInputFontFamily,
                },
                freeAmountLabelStyles: {
                    color: aStyles?.donationFreeAmountLabelColor,
                    fontFamily: aStyles?.donationFreeAmountLabelFontFamily,
                    fontSize: aStyles?.donationFreeAmountLabelFontSize,
                    fontWeight: aStyles?.donationFreeAmountLabelFontWeight,
                },
                infosInputStyles: {
                    background: aStyles?.donationInfosInputBackground,
                    borderColor: aStyles?.donationInfosInputBorderColor,
                    borderRadius: aStyles?.donationInfosInputBorderRadius,
                    borderStyle: aStyles?.donationInfosInputBorderStyle,
                    borderWidth: aStyles?.donationInfosInputBorderWidth,
                    color: aStyles?.donationInfosInputColor,
                    fontFamily: aStyles?.donationInfosInputFontFamily,
                },
                infosLabelStyles: {
                    color: aStyles?.donationInfosLabelColor,
                    fontFamily: aStyles?.donationInfosLabelFontFamily,
                    fontSize: aStyles?.donationInfosLabelFontSize,
                    fontWeight: aStyles?.donationInfosLabelFontWeight,
                },
                mainStyles: {
                    colorMode: aStyles?.colorMode,
                },
                periodStyles: {
                    color: aStyles?.donationPeriodColor,
                    fontFamily: aStyles?.donationPeriodFontFamily,
                    fontSize: aStyles?.donationPeriodFontSize,
                    fontWeight: aStyles?.donationPeriodFontWeight,
                    hoverTextDecorationColor: aStyles?.donationPeriodHoverTextDecorationColor,
                    textDecorationColor: aStyles?.donationPeriodTextDecorationColor,
                    textDecorationLine: aStyles?.donationPeriodTextDecorationLine,
                    textDecorationThickness: aStyles?.donationPeriodTextDecorationThickness,
                    textTransform: aStyles?.donationPeriodTextTransform,
                    textUnderlineOffset: aStyles?.donationPeriodTextUnderlineOffset,
                },
                realCostTextStyles: {
                    color: aStyles?.donationRealCostTextColor,
                    fontSize: aStyles?.donationRealCostTextFontSize,
                    fontWeight: aStyles?.donationRealCostTextFontWeight,
                    letterSpacing: aStyles?.donationRealCostTextLetterSpacing,
                    lineHeight: aStyles?.donationRealCostTextLineHeight,
                    padding: aStyles?.donationRealCostTextPadding,
                },
                secureTextStyles: {
                    color: aStyles?.donationSecureTextColor,
                    fontSize: aStyles?.donationSecureTextFontSize,
                    fontWeight: aStyles?.donationSecureTextFontWeight,
                    letterSpacing: aStyles?.donationSecureTextLetterSpacing,
                    lineHeight: aStyles?.donationSecureTextLineHeight,
                    padding: aStyles?.donationSecureTextPadding,
                },
                titleStyles: {
                    color: aStyles?.donationTitleColor,
                    fontFamily: aStyles?.donationTitleFontFamily,
                    fontSize: aStyles?.donationTitleFontSize,
                    fontWeight: aStyles?.donationTitleFontWeight,
                    textTransform: aStyles?.donationTitleTextTransform,
                },
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'applyStyles',
            ))
        }
    }

    function handleAmountChange(value: any) {
        try {
            setAmount(value)
            setAmountError('')
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'handleAmountChange',
            ))
        }
    }

    function handleEmailChange(event: any) {
        try {
            setEmail(event.target.value)
            setEmailError('')
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock810Site',
                'handleEmailChange',
            ))
        }
    }

    if ([538, 619, 657].includes(reduxCacheSiteportfolioid!)) {
        let amountChoices = [10, 45, 100]
        if (reduxCacheSiteportfolioid === 657) {
            amountChoices = [10, 30, 50]
        }
        if (reduxCacheSiteportfolioid === 619) {
            amountChoices = [20, 40, 60, 100, 200]
        }
        return (
            <>
                <style>
                    {`
                        .t-810-period-choice {
                            text-decoration-color: transparent;
                            &:hover,
                            &.active {
                                text-decoration-color: ${stylesNew?.periodStyles?.hoverTextDecorationColor || 'black'};
                            }
                        }
                        .t-810-block1-button {
                            border-color: transparent;
                            &:hover,
                            &.active {
                                border-color: ${stylesNew?.amountChoiceStyles?.hoverBorderColor || 'black'};
                            }
                        }
                        .t-810-button {
                            background: ${stylesNew?.buttonStyles?.buttonBackground || 'black'};
                            border-color: ${stylesNew?.buttonStyles?.buttonBorderColor || 'transparent'};
                            color: ${stylesNew?.buttonStyles?.buttonTextColor || 'white'};
                            &:hover {
                                background: ${stylesNew?.buttonStyles?.buttonHoverBackground || 'black'};
                                border-color: ${stylesNew?.buttonStyles?.buttonHoverBorderColor || 'transparent'};
                                color: ${stylesNew?.buttonStyles?.buttonHoverTextColor || 'white'};
                            }
                        }
                    `}
                </style>
                <div
                    id={blockId}
                    className={`template-block-810-new${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
                >
                    {parseQuerySite(location.search).success
                        ? (
                            <p className={`t-810-sucess-message ${deviceType}`}>{content?.success_message || reduxText[8519]}</p>
                        ) : (
                            <React.Fragment>
                                <div
                                    className={`t-810-block1 ${deviceType}`}
                                    style={stylesNew?.block1Styles}
                                >
                                    <div className={`t-810-block1-period ${deviceType}`}>
                                        <span
                                            className={`t-810-period-choice${!isRecurent ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setIsRecurent(!isRecurent)}
                                            style={stylesNew?.periodStyles}
                                        >
                                            Ponctuel
                                        </span>
                                        <span
                                            className={`t-810-period-choice${isRecurent ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setIsRecurent(!isRecurent)}
                                            style={stylesNew?.periodStyles}
                                        >
                                            Mensuel
                                        </span>
                                    </div>
                                    <div className={`t-810-block1-amount-choices ${deviceType}`}>
                                        {amountChoices.map((amountChoice) => (
                                            <button
                                                key={amountChoice}
                                                className={`t-810-block1-button${(amount === amountChoice) ? ' active' : ''} ${deviceType}`}
                                                onClick={() => handleAmountChange(amountChoice)}
                                                style={stylesNew?.amountChoiceStyles}
                                                type='button'
                                            >
                                                {amountChoice}€
                                            </button>
                                        ))}
                                    </div>
                                    <div className={`t-810-block1-custom-amount ${deviceType}`}>
                                        <span
                                            className={`t-810-label ${deviceType}`}
                                            style={stylesNew?.freeAmountLabelStyles}
                                        >
                                            Montant libre
                                        </span>
                                        <div className={`t-810-block1-input-wrapper ${deviceType}`}>
                                            <input
                                                className={`t-810-amount ${deviceType}`}
                                                min={0}
                                                name='amount'
                                                onChange={(e) => handleAmountChange(e.target.value)}
                                                style={stylesNew?.freeAmountInputStyles}
                                                tabIndex={1}
                                                type='number'
                                                value={amount}
                                            />
                                            <span className='t-810-currency-symbol'>{reduxCacheSiteportfoliocurrencyiso_code}</span>
                                        </div>
                                        {amountError && (
                                            <span className='t-810-error'>{amountError}</span>
                                        )}
                                    </div>
                                    <p
                                        className={`t-810-real-cost-text${amount > 0 ? ' visible' : ''} ${deviceType}`}
                                        style={stylesNew?.realCostTextStyles}
                                    >
                                        Si vous êtes imposable, votre don ne vous coûte réellement que {Number(amount / 100 * 34).toFixed(2)}€ après réduction d'impôt.
                                    </p>
                                </div>
                                <div
                                    className={`t-810-block2 ${deviceType}`}
                                    style={stylesNew?.block2Styles}
                                >
                                    <span
                                        className={`t-810-title ${deviceType}`}
                                        style={stylesNew?.titleStyles}
                                    >
                                        Mes coordonées
                                    </span>
                                    <span
                                        className={`t-810-label ${deviceType}`}
                                        style={stylesNew?.infosLabelStyles}
                                    >
                                        {reduxText[8503]}
                                    </span>
                                    <input
                                        className={`t-810-email ${deviceType}`}
                                        name='email'
                                        onChange={handleEmailChange}
                                        style={stylesNew?.infosInputStyles}
                                        tabIndex={3}
                                        type='email'
                                        value={email}
                                    />
                                    {emailError && (
                                        <span className='t-810-error'>{emailError}</span>
                                    )}
                                    <Elements stripe={reduxModalSite.stripePromise}>
                                        <ButtonHelper810Site
                                            amount={amount}
                                            buttonText={content?.button_text}
                                            currency={currency}
                                            email={email}
                                            isRecurent={isRecurent}
                                            productId={content?.stripe_product_id}
                                            setAmountError={setAmountError}
                                            setEmailError={setEmailError}
                                        />
                                    </Elements>
                                    <span
                                        className={`t-810-secure ${deviceType}`}
                                        style={stylesNew?.secureTextStyles}
                                    >
                                        {reduxText[8504]}
                                    </span>
                                </div>
                            </React.Fragment>
                        )
                    }
                    <EditBlockSite
                        isInComponent={isInComponent}
                        mainParentId={mainParentId || object.id!}
                        object={object}
                        parentArray={parentArray}
                        parentStyles={parentStyles}
                    />
                </div>
            </>
        )
    }

    return (
        <React.Fragment>
            <style>
                {`
                    .t-810-button {
                        background: ${stylesNew?.buttonStyles?.buttonBackground || 'black'};
                        border-color: ${stylesNew?.buttonStyles?.buttonBorderColor || 'transparent'};
                        color: ${stylesNew?.buttonStyles?.buttonTextColor || 'white'};
                        &:hover {
                            background: ${stylesNew?.buttonStyles?.buttonHoverBackground || 'black'};
                            border-color: ${stylesNew?.buttonStyles?.buttonHoverBorderColor || 'transparent'};
                            color: ${stylesNew?.buttonStyles?.buttonHoverTextColor || 'white'};
                        }
                    }
                `}
            </style>
            <div
                id={blockId}
                className={`template-block-810${isEditHovered ? ' is-edit-hovered' : ''} ${stylesNew?.mainStyles?.colorMode || 'dark'} ${deviceType}`}
            >
                {parseQuerySite(location.search).success
                    ? (
                        <p className={`t-810-sucess-message ${deviceType}`}>{content?.success_message || reduxText[8519]}</p>
                    ) : (
                        <React.Fragment>
                            <span className={`t-810-label ${deviceType}`}>{reduxText[8502]}</span>
                            <input
                                className={`t-810-amount ${deviceType}`}
                                min={0}
                                name='amount'
                                onChange={(e) => handleAmountChange(e.target.value)}
                                step='5'
                                tabIndex={1}
                                type='number'
                                value={amount}
                            />
                            {reduxCacheSiteportfolioid === 619
                                ? (
                                    <div className='t-810-currency-wrapper'>
                                        <span
                                            className={`t-810-currency-item${currency === 'EUR' ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setCurrency('EUR')}
                                        >
                                            EUR
                                        </span>
                                        <span
                                            className={`t-810-currency-item${currency === 'USD' ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setCurrency('USD')}
                                        >
                                            USD
                                        </span>
                                        <span
                                            className={`t-810-currency-item${currency === 'CHF' ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setCurrency('CHF')}
                                        >
                                            CHF
                                        </span>
                                        <span
                                            className={`t-810-currency-item${currency === 'LAK' ? ' active' : ''} ${deviceType}`}
                                            onClick={() => setCurrency('LAK')}
                                        >
                                            LAK
                                        </span>
                                    </div>
                                ) : (
                                    <span className={`t-810-currency ${deviceType}`}>{reduxCacheSiteportfoliocurrencyiso_code}</span>
                                )}
                            {amountError && (
                                <span className='t-810-error'>{amountError}</span>
                            )}
                            <div
                                className={`t-810-monthly-wrap ${deviceType}`}
                                onClick={() => setIsRecurent(!isRecurent)}
                            >
                                <input
                                    checked={isRecurent}
                                    className={`t-810-monthly ${deviceType}`}
                                    name='isRecurent'
                                    tabIndex={2}
                                    type='checkbox'
                                />
                                {reduxText[8501]}
                            </div>
                            <span className={`t-810-label ${deviceType}`}>{reduxText[8503]}</span>
                            <input
                                className={`t-810-email ${deviceType}`}
                                name='email'
                                onChange={handleEmailChange}
                                tabIndex={3}
                                type='email'
                                value={email}
                            />
                            {emailError && (
                                <span className='t-810-error'>{emailError}</span>
                            )}
                            <Elements stripe={reduxModalSite.stripePromise}>
                                <ButtonHelper810Site
                                    amount={amount}
                                    buttonText={content?.button_text}
                                    currency={currency}
                                    email={email}
                                    isRecurent={isRecurent}
                                    productId={content?.stripe_product_id}
                                    setAmountError={setAmountError}
                                    setEmailError={setEmailError}
                                />
                            </Elements>
                            <span className={`t-810-secure ${deviceType}`}>{reduxText[8504]}</span>
                        </React.Fragment>
                    )
                }
                <EditBlockSite
                    isInComponent={isInComponent}
                    mainParentId={mainParentId || object.id!}
                    object={object}
                    parentArray={parentArray}
                    parentStyles={parentStyles}
                />
            </div>
        </React.Fragment>
    )
})
